import { client } from '@@api/client';
import { CONTENT_LANGUAGE_HEADER } from '@@api/constants/headers';
import { type ContentLanguage } from '@@lib/i18n/constants';

export const newsletterListQuery = (
    query: { q?: string; active?: boolean },
    contentLocale: ContentLanguage,
) =>
    client.newsletter.newsletter.getAll.queryOptions({
        query,
        headers: { [CONTENT_LANGUAGE_HEADER]: contentLocale },
    });
